const actions = {
  // generic actions
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
  MQTT_TRX: 'MQTT_TRX',

  FETCH_CASE_LOGS: 'FETCH_CASE_LOGS',
  LOADING_MORE_CASE_LOGS: 'LOADING_MORE_CASE_LOGS',
  FETCHING_CASE_LOGS: 'FETCHING_CASE_LOGS',
  FETCH_CASE_LOGS_SUCCESS: 'FETCH_CASE_LOGS_SUCCESS',
  FETCH_CASE_LOGS_FAILED: 'FETCH_CASE_LOGS_FAILED',
  RESET_CASE_LOGS: 'RESET_CASE_LOGS',

  UNSUBSCRIBE_NOTIFICATION_CREDENTIAL: 'UNSUBSCRIBE_NOTIFICATION_CREDENTIAL',
  UNSUBSCRIBING_NOTIFICATION_CREDENTIAL: 'UNSUBSCRIBING_NOTIFICATION_CREDENTIAL',
  UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_SUCCESS: 'UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_SUCCESS',
  UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED: 'UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED',
  UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_CLEAR_MESSAGE:
    'UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_CLEAR_MESSAGE',

  FETCH_RECONCILIATION_DATA_BY_PCHANNEL: 'FETCH_RECONCILIATION_DATA_BY_PCHANNEL',
  FETCHING_RECONCILIATION_DATA_BY_PCHANNEL: 'FETCHING_RECONCILIATION_DATA_BY_PCHANNEL',
  FETCH_RECONCILIATION_DATA_BY_PCHANNEL_SUCCESS: 'FETCH_RECONCILIATION_DATA_BY_PCHANNEL_SUCCESS',
  FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED: 'FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED',
  RESET_RECONCILIATION_DATA_BY_PCHANNEL: 'RESET_RECONCILIATION_DATA_BY_PCHANNEL',

  FETCH_SETTLEMENT_REPORT: 'FETCH_SETTLEMENT_REPORT',
  FETCHING_SETTLEMENT_REPORT: 'FETCHING_SETTLEMENT_REPORT',
  LOAD_MORE_SETTLEMENT_REPORT: 'LOAD_MORE_SETTLEMENT_REPORT',
  FETCH_SETTLEMENT_REPORT_SUCCESS: 'FETCH_SETTLEMENT_REPORT_SUCCESS',
  FETCH_SETTLEMENT_REPORT_FAILED: 'FETCH_SETTLEMENT_REPORT_FAILED',
  RESET_SETTLEMENT_REPORT: 'RESET_SETTLEMENT_REPORT',

  FETCH_MONTH_SETTLEMENT_REPORT: 'FETCH_MONTH_SETTLEMENT_REPORT',
  FETCHING_MONTH_SETTLEMENT_REPORT: 'FETCHING_MONTH_SETTLEMENT_REPORT',
  LOAD_MORE_MONTH_SETTLEMENT_REPORT: 'LOAD_MORE_MONTH_SETTLEMENT_REPORT',
  FETCH_MONTH_SETTLEMENT_REPORT_SUCCESS: 'FETCH_MONTH_SETTLEMENT_REPORT_SUCCESS',
  FETCH_MONTH_SETTLEMENT_REPORT_FAILED: 'FETCH_MONTH_SETTLEMENT_REPORT_FAILED',
  RESET_MONTH_SETTLEMENT_REPORT: 'RESET_MONTH_SETTLEMENT_REPORT',

  FETCH_BILLING_DATA_BY_MERCHANT: 'FETCH_BILLING_DATA_BY_MERCHANT',
  FETCHING_BILLING_DATA_BY_MERCHANT: 'FETCHING_BILLING_DATA_BY_MERCHANT',
  FETCH_BILLING_DATA_BY_MERCHANT_SUCCESS: 'FETCH_BILLING_DATA_BY_MERCHANT_SUCCESS',
  FETCH_BILLING_DATA_BY_MERCHANT_FAILED: 'FETCH_BILLING_DATA_BY_MERCHANT_FAILED',
  RESET_BILLING_DATA_BY_MERCHANT: 'RESET_BILLING_DATA_BY_MERCHANT',

  FETCH_BILLING_DETAILS: 'FETCH_BILLING_DETAILS',
  FETCHING_BILLING_DETAILS: 'FETCHING_BILLING_DETAILS',
  FETCH_BILLING_DETAILS_SUCCESS: 'FETCH_BILLING_DETAILS_SUCCESS',
  FETCH_BILLING_DETAILS_FAILED: 'FETCH_BILLING_DETAILS_FAILED',
  RESET_BILLING_DETAILS: 'RESET_BILLING_DETAILS',

  FETCH_COLLATED_DATA_BY_PCHANNEL: 'FETCH_COLLATED_DATA_BY_PCHANNEL',
  FETCHING_COLLATED_DATA_BY_PCHANNEL: 'FETCHING_COLLATED_DATA_BY_PCHANNEL',
  FETCH_COLLATED_DATA_BY_PCHANNEL_SUCCESS: 'FETCH_COLLATED_DATA_BY_PCHANNEL_SUCCESS',
  FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED: 'FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED',
  RESET_COLLATED_DATA_BY_PCHANNEL: 'RESET_COLLATED_DATA_BY_PCHANNEL',

  FETCH_BILLER_DETAILS: 'FETCH_BILLER_DETAILS',
  FETCHING_BILLER_DETAILS: 'FETCHING_BILLER_DETAILS',
  FETCH_BILLER_DETAILS_SUCCESS: 'FETCH_BILLER_DETAILS_SUCCESS',
  FETCH_BILLER_DETAILS_FAILED: 'FETCH_BILLER_DETAILS_FAILED',
  RESET_BILLER_DETAILS: 'RESET_BILLER_DETAILS',

  // start: response code
  FETCH_RESPONSE_CODE: 'FETCH_RESPONSE_CODE',
  FETCHING_RESPONSE_CODE: 'FETCHING_RESPONSE_CODE',
  FETCH_RESPONSE_CODE_SUCCESS: 'FETCH_RESPONSE_CODE_SUCCESS',
  FETCH_RESPONSE_CODE_FAILED: 'FETCH_RESPONSE_CODE_FAILED',

  ADD_RESPONSE_CODE: 'ADD_RESPONSE_CODE',
  ADDING_RESPONSE_CODE: 'ADDING_RESPONSE_CODE',
  ADD_RESPONSE_CODE_SUCCESS: 'ADD_RESPONSE_CODE_SUCCESS',
  ADD_RESPONSE_CODE_FAILED: 'ADD_RESPONSE_CODE_FAILED',

  EDIT_RESPONSE_CODE: 'EDIT_RESPONSE_CODE',
  EDITING_RESPONSE_CODE: 'EDITING_RESPONSE_CODE',
  EDIT_RESPONSE_CODE_SUCCESS: 'EDIT_RESPONSE_CODE_SUCCESS',
  EDIT_RESPONSE_CODE_FAILED: 'EDIT_RESPONSE_CODE_FAILED',

  EDIT_SETTLEMENT_RATE: 'EDIT_SETTLEMENT_RATE',
  EDITING_SETTLEMENT_RATE: 'EDITING_SETTLEMENT_RATE',
  EDIT_SETTLEMENT_RATE_SUCCESS: 'EDIT_SETTLEMENT_RATE_SUCCESS',
  EDIT_SETTLEMENT_RATE_FAILED: 'EDIT_SETTLEMENT_RATE_FAILED',

  CHANGE_STATUS_RESPONSE_CODE: 'CHANGE_STATUS_RESPONSE_CODE',
  CHANGING_STATUS_RESPONSE_CODE: 'CHANGING_STATUS_RESPONSE_CODE',
  CHANGE_STATUS_RESPONSE_CODE_SUCCESS: 'CHANGE_STATUS_RESPONSE_CODE_SUCCESS',
  CHANGE_STATUS_RESPONSE_CODE_FAILED: 'CHANGE_STATUS_RESPONSE_CODE_FAILED',
  // end: response code

  // start: security code
  FETCH_SECURITY_CODE: 'FETCH_SECURITY_CODE',
  FETCHING_SECURITY_CODE: 'FETCHING_SECURITY_CODE',
  FETCH_SECURITY_CODE_SUCCESS: 'FETCH_SECURITY_CODE_SUCCESS',
  FETCH_SECURITY_CODE_FAILED: 'FETCH_SECURITY_CODE_FAILED',

  ADD_SECURITY_CODE: 'ADD_SECURITY_CODE',
  ADDING_SECURITY_CODE: 'ADDING_SECURITY_CODE',
  ADD_SECURITY_CODE_SUCCESS: 'ADD_SECURITY_CODE_SUCCESS',
  ADD_SECURITY_CODE_FAILED: 'ADD_SECURITY_CODE_FAILED',

  EDIT_SECURITY_CODE: 'EDIT_SECURITY_CODE',
  EDITING_SECURITY_CODE: 'EDITING_SECURITY_CODE',
  EDIT_SECURITY_CODE_SUCCESS: 'EDIT_SECURITY_CODE_SUCCESS',
  EDIT_SECURITY_CODE_FAILED: 'EDIT_SECURITY_CODE_FAILED',

  // CHANGE_STATUS_SECURITY_CODE: 'CHANGE_STATUS_SECURITY_CODE',
  // CHANGING_STATUS_SECURITY_CODE: 'CHANGING_STATUS_SECURITY_CODE',
  // CHANGE_STATUS_SECURITY_CODE_SUCCESS: 'CHANGE_STATUS_SECURITY_CODE_SUCCESS',
  // CHANGE_STATUS_SECURITY_CODE_FAILED: 'CHANGE_STATUS_SECURITY_CODE_FAILED',
  // end: security code

  ADD_BILLING_DATA_BY_MERCHANT_ID: 'ADD_BILLING_DATA_BY_MERCHANT_ID',
  ADDING_BILLING_DATA_BY_MERCHANT_ID: 'ADDING_BILLING_DATA_BY_MERCHANT_ID',
  ADD_BILLING_DATA_BY_MERCHANT_ID_SUCCESS: 'ADD_BILLING_DATA_BY_MERCHANT_ID_SUCCESS',
  ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED: 'ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED',

  ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA: 'ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA',
  ANALYZING_COLLATE_DATA_BY_PCHANNEL_DATA: 'ANALYZING_COLLATE_DATA_BY_PCHANNEL_DATA',
  ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_SUCCESS: 'ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_SUCCESS',
  ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED: 'ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED',
  ANALYZE_COLLATE_DATA_GENERATING_LOADING: 'ANALYZE_COLLATE_DATA_GENERATING_LOADING',

  GENERATE_REPORT_DATA: 'GENERATE_REPORT_DATA',
  GENERATING_REPORT_DATA: 'GENERATING_REPORT_DATA',
  GENERATE_REPORT_DATA_SUCCESS: 'GENERATE_REPORT_DATA_SUCCESS',
  GENERATE_REPORT_DATA_FAILED: 'GENERATE_REPORT_DATA_FAILED',
  STORE_PENDING_RECONCILED_REPORT_DATA: 'STORE_PENDING_RECONCILED_REPORT_DATA',

  DOWNLOAD_SETTLEMENT_REPORT_DATA: 'DOWNLOAD_SETTLEMENT_REPORT_DATA',
  DOWNLOADING_SETTLEMENT_REPORT_DATA: 'DOWNLOADING_SETTLEMENT_REPORT_DATA',
  DOWNLOAD_SETTLEMENT_REPORT_DATA_SUCCESS: 'DOWNLOAD_SETTLEMENT_REPORT_DATA_SUCCESS',
  DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED: 'DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED',

  GENERATE_UNRECONCILED_REPORT_DATA: 'GENERATE_UNRECONCILED_REPORT_DATA',
  GENERATING_UNRECONCILED_REPORT_DATA: 'GENERATING_UNRECONCILED_REPORT_DATA',
  GENERATE_UNRECONCILED_REPORT_DATA_SUCCESS: 'GENERATE_UNRECONCILED_REPORT_DATA_SUCCESS',
  GENERATE_UNRECONCILED_REPORT_DATA_FAILED: 'GENERATE_UNRECONCILED_REPORT_DATA_FAILED',
  STORE_PENDING_UNRECONCILED_REPORT_DATA: 'STORE_PENDING_UNRECONCILED_REPORT_DATA',

  GENERATE_MONTH_REPORT_DATA: 'GENERATE_MONTH_REPORT_DATA',
  GENERATING_MONTH_REPORT_DATA: 'GENERATING_MONTH_REPORT_DATA',
  GENERATE_MONTH_REPORT_DATA_SUCCESS: 'GENERATE_MONTH_REPORT_DATA_SUCCESS',
  GENERATE_MONTH_REPORT_DATA_FAILED: 'GENERATE_MONTH_REPORT_DATA_FAILED',
  STORE_PENDING_MONTH_REPORT_DATA: 'STORE_PENDING_MONTH_REPORT_DATA',

  DOWNLOAD_MONTHLY_RECONCILED_REPORT: 'DOWNLOAD_MONTHLY_RECONCILED_REPORT',
  DOWNLOADING_MONTHLY_RECONCILED_REPORT: 'DOWNLOADING_MONTHLY_RECONCILED_REPORT',
  DOWNLOAD_MONTHLY_RECONCILED_REPORT_SUCCESS: 'DOWNLOAD_MONTHLY_RECONCILED_REPORT_SUCCESS',
  DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED: 'DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED',

  FETCH_CASE_DETAILS_DATA: 'FETCH_CASE_DETAILS_DATA',
  FETCHING_CASE_DETAILS_DATA: 'FETCHING_CASE_DETAILS_DATA',
  FETCH_CASE_DETAILS_DATA_SUCCESS: 'FETCH_CASE_DETAILS_DATA_SUCCESS',
  FETCH_CASE_DETAILS_DATA_FAILED: 'FETCH_CASE_DETAILS_DATA_FAILED',
  RESET_CASE_DETAILS: 'RESET_CASE_DETAILS',

  DOWNLOAD_CASE_DISCUSSION_ATTACHMENT: 'DOWNLOAD_CASE_DISCUSSION_ATTACHMENT',
  DOWNLOADING_CASE_DISCUSSION_ATTACHMENT: 'DOWNLOADING_CASE_DISCUSSION_ATTACHMENT',
  DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_SUCCESS: 'DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_SUCCESS',
  DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED: 'DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED',

  INVITE_CASE_MEMBER: 'INVITE_CASE_MEMBER',
  INVITING_CASE_MEMBER: 'INVITING_CASE_MEMBER',
  INVITE_CASE_MEMBER_SUCCESS: 'INVITE_CASE_MEMBER_SUCCESS',
  INVITE_CASE_MEMBER_FAILED: 'INVITE_CASE_MEMBER_FAILED',

  DOWNLOAD_UNRECONCILED_REPORT_DATA: 'DOWNLOAD_UNRECONCILED_REPORT_DATA',
  DOWNLOADING_UNRECONCILED_REPORT_DATA: 'DOWNLOADING_UNRECONCILED_REPORT_DATA',
  DOWNLOAD_UNRECONCILED_REPORT_DATA_SUCCESS: 'DOWNLOAD_UNRECONCILED_REPORT_DATA_SUCCESS',
  DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED: 'DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED',

  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV: 'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV',
  CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV:
    'CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV',
  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_SUCCESS:
    'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_SUCCESS',
  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED:
    'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED',

  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE:
    'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE',
  CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE:
    'CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE',
  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_SUCCESS:
    'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_SUCCESS',
  CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED:
    'CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED',

  FETCH_FINANCE_DASHBOARD_DATA: 'FETCH_FINANCE_DASHBOARD_DATA',
  FETCHING_FINANCE_DASHBOARD_DATA: 'FETCHING_FINANCE_DASHBOARD_DATA',
  FETCH_FINANCE_DASHBOARD_DATA_SUCCESS: 'FETCH_FINANCE_DASHBOARD_DATA_SUCCESS',
  FETCH_FINANCE_DASHBOARD_DATA_FAILED: 'FETCH_FINANCE_DASHBOARD_DATA_FAILED',

  CHECK_COLLATE_DATA: 'CHECK_COLLATE_DATA',
  CHECKING_COLLATE_DATA: 'CHECKING_COLLATE_DATA',
  CHECK_COLLATE_DATA_SUCCESS: 'CHECK_COLLATE_DATA_SUCCESS',
  CHECK_COLLATE_DATA_FAILED: 'CHECK_COLLATE_DATA_FAILED',
  CHECK_COLLATE_DATA_MQTT_LOADING: 'CHECK_COLLATE_DATA_MQTT_LOADING',

  FETCH_ALL_RECONCILED_DATA: 'FETCH_ALL_RECONCILED_DATA',
  FETCHING_ALL_RECONCILED_DATA: 'FETCHING_ALL_RECONCILED_DATA',
  FETCH_ALL_RECONCILED_DATA_SUCCESS: 'FETCH_ALL_RECONCILED_DATA_SUCCESS',
  FETCH_ALL_RECONCILED_DATA_FAILED: 'FETCH_ALL_RECONCILED_DATA_FAILED',

  PARSE_DATA_FILE_NOTIFIER: 'PARSE_DATA_FILE_NOTIFIER',
  RESET_PARSE_DATA_FILE_NOTIFIER: 'RESET_PARSE_DATA_FILE_NOTIFIER',

  PARSE_LEAD_DATA_FILE_NOTIFIER: 'PARSE_LEAD_DATA_FILE_NOTIFIER',
  RESET_PARSE_LEAD_DATA_FILE_NOTIFIER: 'RESET_PARSE_LEAD_DATA_FILE_NOTIFIER',

  FETCH_UNRECONCILED_REPORT_LIST: 'FETCH_UNRECONCILED_REPORT_LIST',
  FETCHING_UNRECONCILED_REPORT_LIST: 'FETCHING_UNRECONCILED_REPORT_LIST',
  LOAD_MORE_UNRECONCILED_REPORT_LIST: 'LOAD_MORE_UNRECONCILED_REPORT_LIST',
  FETCH_UNRECONCILED_REPORT_LIST_SUCCESS: 'FETCH_UNRECONCILED_REPORT_LIST_SUCCESS',
  FETCH_UNRECONCILED_REPORT_LIST_FAILED: 'FETCH_UNRECONCILED_REPORT_LIST_FAILED',
  RESET_UNRECONCILED_REPORT_LIST_FAILED: 'RESET_UNRECONCILED_REPORT_LIST_FAILED',

  ESCALATE_TRANSACTION_DATA: 'ESCALATE_TRANSACTION_DATA',
  ESCALATING_TRANSACTION_DATA: 'ESCALATING_TRANSACTION_DATA',
  ESCALATE_TRANSACTION_DATA_SUCCESS: 'ESCALATE_TRANSACTION_DATA_SUCCESS',
  ESCALATE_TRANSACTION_DATA_FAILED: 'ESCALATE_TRANSACTION_DATA_FAILED',

  FETCH_CASE_DISCUSSIONS: 'FETCH_CASE_DISCUSSIONS',
  SET_DISCUSSION_VALUE: 'SET_DISCUSSION_VALUE',
  LOAD_MORE_CASE_DISCUSSIONS: 'LOAD_MORE_CASE_DISCUSSIONS',
  FETCHING_CASE_DISCUSSIONS: 'FETCHING_CASE_DISCUSSIONS',
  FETCH_CASE_DISCUSSIONS_SUCCESS: 'FETCH_CASE_DISCUSSIONS_SUCCESS',
  FETCH_CASE_DISCUSSIONS_FAILED: 'FETCH_CASE_DISCUSSIONS_FAILED',

  LIKE_DISCUSSION_DATA: 'LIKE_DISCUSSION_DATA',
  LIKE_CURRENT_ID: 'LIKE_CURRENT_ID',
  LIKING_TRANSACTION_DATA: 'LIKING_TRANSACTION_DATA',
  LIKE_DISCUSSION_DATA_SUCCESS: 'LIKE_DISCUSSION_DATA_SUCCESS',
  LIKE_DISCUSSION_DATA_FAILED: 'LIKE_DISCUSSION_DATA_FAILED',

  STORE_ATTACHED_CASE_FILES_FOR_UPLOAD: 'STORE_ATTACHED_CASE_FILES_FOR_UPLOAD',
  STORING_ATTACHED_CASE_FILES_FOR_UPLOAD: 'STORING_ATTACHED_CASE_FILES_FOR_UPLOAD',
  STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_SUCCESS: 'STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_SUCCESS',
  STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_FAILED: 'STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_FAILED',

  SEND_DISCUSSION_ITEM: 'SEND_DISCUSSION_ITEM',
  SENDING_DISCUSSION_ITEM: 'SENDING_DISCUSSION_ITEM',
  SEND_DISCUSSION_ITEM_SUCCESS: 'SEND_DISCUSSION_ITEM_SUCCESS',
  SEND_DISCUSSION_ITEM_FAILED: 'SEND_DISCUSSION_ITEM_FAILED',

  FETCH_CASE_TRANSACTION_DATA: 'FETCH_CASE_TRANSACTION_DATA',
  FETCHING_CASE_TRANSACTION_DATA: 'FETCHING_CASE_TRANSACTION_DATA',
  FETCH_CASE_TRANSACTION_DATA_SUCCESS: 'FETCH_CASE_TRANSACTION_DATA_SUCCESS',
  FETCH_CASE_TRANSACTION_DATA_FAILED: 'FETCH_CASE_TRANSACTION_DATA_FAILED',
  LOAD_MORE_CASE_TRANSACTIONS: 'LOAD_MORE_CASE_TRANSACTIONS',
  SETUP_CASE_DETAIL: 'SETUP_CASE_DETAIL',

  UPDATE_CASE_DETAILS: 'UPDATE_CASE_DETAILS',
  UPDATING_CASE_DETAILS: 'UPDATING_CASE_DETAILS',
  UPDATE_CASE_DETAILS_SUCCESS: 'UPDATE_CASE_DETAILS_SUCCESS',
  UPDATE_CASE_DETAILS_FAILED: 'UPDATE_CASE_DETAILS_FAILED',

  FETCH_UPLOADED_BANK_FILES: 'FETCH_UPLOADED_BANK_FILES',
  FETCHING_UPLOADED_BANK_FILES: 'FETCHING_UPLOADED_BANK_FILES',
  FETCH_UPLOADED_BANK_FILES_SUCCESS: 'FETCH_UPLOADED_BANK_FILES_SUCCESS',
  FETCH_UPLOADED_BANK_FILES_FAILED: 'FETCH_UPLOADED_BANK_FILES_FAILED',

  FETCH_UPLOADED_BANK_TRANSACTION: 'FETCH_UPLOADED_BANK_TRANSACTION',
  FETCHING_UPLOADED_BANK_TRANSACTION: 'FETCHING_UPLOADED_BANK_TRANSACTION',
  FETCH_UPLOADED_BANK_TRANSACTION_SUCCESS: 'FETCH_UPLOADED_BANK_TRANSACTION_SUCCESS',
  FETCH_UPLOADED_BANK_TRANSACTION_FAILED: 'FETCH_UPLOADED_BANK_TRANSACTION_FAILED',

  UPDATE_BANK_REMITTANCE: 'UPDATE_BANK_REMITTANCE',
  UPDATING_BANK_REMITTANCE: 'UPDATING_BANK_REMITTANCE',
  UPDATE_BANK_REMITTANCE_SUCCESS: 'UPDATE_BANK_REMITTANCE_SUCCESS',
  UPDATE_BANK_REMITTANCE_FAILED: 'UPDATE_BANK_REMITTANCE_FAILED',

  UPDATE_BANK_TRANSACTION: 'UPDATE_BANK_TRANSACTION',
  UPDATING_BANK_TRANSACTION: 'UPDATING_BANK_TRANSACTION',
  UPDATE_BANK_TRANSACTION_SUCCESS: 'UPDATE_BANK_TRANSACTION_SUCCESS',
  UPDATE_BANK_TRANSACTION_FAILED: 'UPDATE_BANK_TRANSACTION_FAILED',

  UPDATE_BANK_FILE: 'UPDATE_BANK_FILE',
  UPDATING_BANK_FILE: 'UPDATING_BANK_FILE',
  UPDATE_BANK_FILE_SUCCESS: 'UPDATE_BANK_FILE_SUCCESS',
  UPDATE_BANK_FILE_FAILED: 'UPDATE_BANK_FILE_FAILED',

  GENERATE_BANK_TRANSACTION_STATISTICS: 'GENERATE_BANK_TRANSACTION_STATISTICS',
  GENERATING_BANK_TRANSACTION_STATISTICS: 'GENERATING_BANK_TRANSACTION_STATISTICS',
  GENERATE_BANK_TRANSACTION_STATISTICS_SUCCESS: 'GENERATE_BANK_TRANSACTION_STATISTICS_SUCCESS',
  GENERATE_BANK_TRANSACTION_STATISTICS_FAILED: 'GENERATE_BANK_TRANSACTION_STATISTICS_FAILED',

  FETCH_ALL_REMITTING_CHANNEL_SCHEDULE: 'FETCH_ALL_REMITTING_CHANNEL_SCHEDULE',
  FETCHING_ALL_REMITTING_CHANNEL_SCHEDULE: 'FETCHING_ALL_REMITTING_CHANNEL_SCHEDULE',
  FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_SUCCESS: 'FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_SUCCESS',
  FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_FAILED: 'FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_FAILED',

  ADD_REMITTING_CHANNEL_SCHEDULE: 'ADD_REMITTING_CHANNEL_SCHEDULE',
  ADDING_REMITTING_CHANNEL_SCHEDULE: 'ADDING_REMITTING_CHANNEL_SCHEDULE',
  ADD_REMITTING_CHANNEL_SCHEDULE_SUCCESS: 'ADD_REMITTING_CHANNEL_SCHEDULE_SUCCESS',
  ADD_REMITTING_CHANNEL_SCHEDULE_FAILED: 'ADD_REMITTING_CHANNEL_SCHEDULE_FAILED',

  EDIT_REMITTING_CHANNEL_SCHEDULE: 'EDIT_REMITTING_CHANNEL_SCHEDULE',
  EDITING_REMITTING_CHANNEL_SCHEDULE: 'EDITING_REMITTING_CHANNEL_SCHEDULE',
  EDIT_REMITTING_CHANNEL_SCHEDULE_SUCCESS: 'EDIT_REMITTING_CHANNEL_SCHEDULE_SUCCESS',
  EDIT_REMITTING_CHANNEL_SCHEDULE_FAILED: 'EDIT_REMITTING_CHANNEL_SCHEDULE_FAILED',

  DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS: 'DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS',
  DELETING_UPLOADED_BANK_FILE_AND_TRANSACTIONS: 'DELETING_UPLOADED_BANK_FILE_AND_TRANSACTIONS',
  DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_SUCCESS:
    'DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_SUCCESS',
  DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_FAILED:
    'DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_FAILED',

  SET_ACTIVE_CHANNEL_SCHEDULE: 'SET_ACTIVE_CHANNEL_SCHEDULE',
  SET_PNX_BANK_COLUMN: 'SET_PNX_BANK_COLUMN',

  //Fetch Transaction List
  FETCH_TRANSACTION_LIST: 'FETCH_TRANSACTION_LIST',
  FETCHING_TRANSACTION_LIST: 'FETCHING_TRANSACTION_LIST',
  FETCHING_MORE_TRANSACTION_LIST: 'FETCHING_MORE_TRANSACTION_LIST',
  FETCHED_TRANSACTION_LIST: 'FETCHED_TRANSACTION_LIST',
  FETCHED_TRANSACTION_LIST_FINAL: 'FETCHED_TRANSACTION_LIST_FINAL',
  FETCH_TRANSACTION_LIST_FAILED: 'FETCH_TRANSACTION_LIST_FAILED',
  FETCH_TRANSACTION_LIST_RESET: 'FETCH_TRANSACTION_LIST_RESET',

  //Fetch Transaction Details
  FETCH_TRANSACTION_DETAILS: 'FETCH_TRANSACTION_DETAILS',
  FETCHING_TRANSACTION_DETAILS: 'FETCHING_TRANSACTION_DETAILS',
  FETCHED_TRANSACTION_DETAILS: 'FETCHED_TRANSACTION_DETAILS',
  FETCH_TRANSACTION_DETAILS_FAILED: 'FETCH_TRANSACTION_DETAILS_FAILED',

  // OTC Transactions Actions
  FETCH_OTC_TRANSACTIONS: 'FETCH_OTC_TRANSACTIONS',
  FETCHING_OTC_TRANSACTIONS: 'FETCHING_OTC_TRANSACTIONS',
  FETCH_OTC_TRANSACTIONS_SUCCESS: 'FETCH_OTC_TRANSACTIONS_SUCCESS',
  FETCH_OTC_TRANSACTIONS_FAILED: 'FETCH_OTC_TRANSACTIONS_FAILED',

  UPDATE_OTC_TRANSACTIONS: 'UPDATE_OTC_TRANSACTIONS',
  UPDATING_OTC_TRANSACTIONS: 'UPDATING_OTC_TRANSACTIONS',
  UPDATE_OTC_TRANSACTIONS_SUCCESS: 'UPDATE_OTC_TRANSACTIONS_SUCCESS',
  UPDATE_OTC_TRANSACTIONS_FAILED: 'UPDATE_OTC_TRANSACTIONS_FAILED',

  //Reset Transaction List Filter
  RESET_TRANSACTION_LIST: 'RESET_TRANSACTION_LIST',

  SET_IS_FILTERED: 'SET_IS_FILTERED',

  //Reset Transaction Details
  RESET_TRANSACTION_DETAILS: 'RESET_TRANSACTION_DETAILS',

  // DOWNLOAD CSV TRANSACTION
  DOWNLOAD_CSV: 'DOWNLOAD_CSV',
  DOWNLOADING_CSV: 'DOWNLOADING_CSV',
  DOWNLOADED_CSV: 'DOWNLOADED_CSV',
  DOWNLOD_FAILED_CSV: 'DOWNLOD_FAILED_CSV',
  CLEAR_DOWNLOAD_CSV: 'CLEAR_DOWNLOAD_CSV',

  DOWNLOAD_STATUS: 'DOWNLOAD_STATUS',

  //Fetch Download List
  FETCH_EXCEL_DOWNLOAD_LIST: 'FETCH_EXCEL_DOWNLOAD_LIST',
  FETCHING_EXCEL_DOWNLOAD_LIST: 'FETCHING_EXCEL_DOWNLOAD_LIST',
  FETCHED_EXCEL_DOWNLOAD_LIST: 'FETCHED_EXCEL_DOWNLOAD_LIST',
  FETCH_EXCEL_DOWNLOAD_LIST_FAILED: 'FETCH_EXCEL_DOWNLOAD_LIST_FAILED',

  //Fetch Previous Downloads
  FETCH_PREVIOUS_DOWNLOADS: 'FETCH_PREVIOUS_DOWNLOADS',
  FETCHING_PREVIOUS_DOWNLOADS: 'FETCHING_PREVIOUS_DOWNLOADS',
  FETCHED_PREVIOUS_DOWNLOADS: 'FETCHED_PREVIOUS_DOWNLOADS',
  FETCH_PREVIOUS_DOWNLOADS_FAILED: 'FETCH_PREVIOUS_DOWNLOADS_FAILED',

  // Fetch Merchants
  FETCH_MERCHANTS: 'FETCH_MERCHANTS',
  FETCHING_MERCHANTS: 'FETCHING_MERCHANTS',
  FETCHED_MERCHANTS: 'FETCHED_MERCHANTS',
  FETCH_MERCHANTS_FAILED: 'FETCH_MERCHANTS_FAILED',

  FETCH_DOWNLOAD_REPORT: 'FETCH_DOWNLOAD_REPORT',
  FETCH_DOWNLOAD_REPORT_FAILED: 'FETCH_DOWNLOAD_REPORT_FAILED',
  FETCHING_DOWNLOAD_REPORT: 'FETCHING_DOWNLOAD_REPORT',
  FETCHED_DOWNLOAD_REPORT: 'FETCHED_DOWNLOAD_REPORT',

  //Fetch Custom Merchant Params
  FETCH_CUSTOM_MERCHANT_PARAMS: 'FETCH_CUSTOM_MERCHANT_PARAMS',
  FETCHING_CUSTOM_MERCHANT_PARAMS: 'FETCHING_CUSTOM_MERCHANT_PARAMS',
  FETCHED_CUSTOM_MERCHANT_PARAMS: 'FETCHED_CUSTOM_MERCHANT_PARAMS',
  FETCH_CUSTOM_MERCHANT_PARAMS_FAILED: 'FETCH_CUSTOM_MERCHANT_PARAMS_FAILED',
  FETCH_CUSTOM_MERCHANT_PARAMS_RESET: 'FETCH_CUSTOM_MERCHANT_PARAMS_RESET',

  // Fetch Finance Operations
  FETCH_ALL_FINANCE_OPERATIONS: 'FETCH_ALL_FINANCE_OPERATIONS',
  FETCHING_ALL_FINANCE_OPERATIONS: 'FETCHING_ALL_FINANCE_OPERATIONS',
  FETCH_ALL_FINANCE_OPERATIONS_SUCCESS: 'FETCH_ALL_FINANCE_OPERATIONS_SUCCESS',
  FETCH_ALL_FINANCE_OPERATIONS_FAILED: 'FETCH_ALL_FINANCE_OPERATIONS_FAILED',
  LOADING_MORE_FINANCE_OPERATIONS: 'LOADING_MORE_FINANCE_OPERATIONS',

  FETCH_FINANCE_OPERATIONS_BY_ID: 'FETCH_FINANCE_OPERATIONS_BY_ID',
  FETCHING_FINANCE_OPERATIONS_BY_ID: 'FETCHING_FINANCE_OPERATIONS_BY_ID',
  FETCH_FINANCE_OPERATIONS_BY_ID_SUCCESS: 'FETCH_FINANCE_OPERATIONS_BY_ID_SUCCESS',
  FETCH_FINANCE_OPERATIONS_BY_ID_FAILED: 'FETCH_FINANCE_OPERATIONS_BY_ID_FAILED',
  RESET_ACTIVE_FINANCE_OPERATIONS_BY_ID: 'RESET_ACTIVE_FINANCE_OPERATIONS_BY_ID',

  FETCH_FINANCE_OPERATIONS_LOGS: 'FETCH_FINANCE_OPERATIONS_LOGS',
  LOADING_MORE_FINANCE_OPERATIONS_LOGS: 'LOADING_MORE_FINANCE_OPERATIONS_LOGS',
  FETCHING_FINANCE_OPERATIONS_LOGS: 'FETCHING_FINANCE_OPERATIONS_LOGS',
  FETCH_FINANCE_OPERATIONS_LOGS_SUCCESS: 'FETCH_FINANCE_OPERATIONS_LOGS_SUCCESS',
  FETCH_FINANCE_OPERATIONS_LOGS_FAILED: 'FETCH_FINANCE_OPERATIONS_LOGS_FAILED',
  RESET_FINANCE_OPERATIONS_LOGS: 'RESET_FINANCE_OPERATIONS_LOGS',

  DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE: 'DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE',
  DOWNLOADING_VAT_EXEMPTION_FILE_FINANCE: 'DOWNLOADING_VAT_EXEMPTION_FILE_FINANCE',
  DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_SUCCESS: 'DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_SUCCESS',
  DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED: 'DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED',

  DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE: 'DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE',
  DOWNLOADING_PAYMENT_PROOF_FILE_FINANCE: 'DOWNLOADING_PAYMENT_PROOF_FILE_FINANCE',
  DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_SUCCESS: 'DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_SUCCESS',
  DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED: 'DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED',

  APPROVE_VAT_EXEMPTION_FILE: 'APPROVE_VAT_EXEMPTION_FILE',
  APPROVING_VAT_EXEMPTION_FILE: 'APPROVING_VAT_EXEMPTION_FILE',
  APPROVE_VAT_EXEMPTION_FILE_SUCCESS: 'APPROVE_VAT_EXEMPTION_FILE_SUCCESS',
  APPROVE_VAT_EXEMPTION_FILE_FAILED: 'APPROVE_VAT_EXEMPTION_FILE_FAILED',

  CONFIRM_PAYMENT_PROOF_FILE: 'CONFIRM_PAYMENT_PROOF_FILE',
  CONFIRMING_PAYMENT_PROOF_FILE: 'CONFIRMING_PAYMENT_PROOF_FILE',
  CONFIRM_PAYMENT_PROOF_FILE_SUCCESS: 'CONFIRM_PAYMENT_PROOF_FILE_SUCCESS',
  CONFIRM_PAYMENT_PROOF_FILE_FAILED: 'CONFIRM_PAYMENT_PROOF_FILE_FAILED',

  REJECT_VAT_EXEMPTION_FILE: 'REJECT_VAT_EXEMPTION_FILE',
  REJECTING_VAT_EXEMPTION_FILE: 'REJECTING_VAT_EXEMPTION_FILE',
  REJECT_VAT_EXEMPTION_FILE_SUCCESS: 'REJECT_VAT_EXEMPTION_FILE_SUCCESS',
  REJECT_VAT_EXEMPTION_FILE_FAILED: 'REJECT_VAT_EXEMPTION_FILE_FAILED',

  RESET_FINANCE_OPERATIONS: 'RESET_FINANCE_OPERATIONS',

  VIEW_CONFIDENTIAL_BANK_DETAILS: 'VIEW_CONFIDENTIAL_BANK_DETAILS',
  VIEWING_CONFIDENTIAL_BANK_DETAILS: 'VIEWING_CONFIDENTIAL_BANK_DETAILS',
  VIEW_CONFIDENTIAL_BANK_DETAILS_SUCCESS: 'VIEW_CONFIDENTIAL_BANK_DETAILS_SUCCESS',
  VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED: 'VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED',

  EDIT_INVOICE: 'EDIT_INVOICE',
  EDITING_INVOICE: 'EDITING_INVOICE',
  EDIT_INVOICE_SUCCESS: 'EDIT_INVOICE_SUCCESS',
  EDIT_INVOICE_FAILED: 'EDIT_INVOICE_FAILED',

  VIEW_INVOICE_PDF: 'VIEW_INVOICE_PDF',
  VIEWING_INVOICE_PDF: 'VIEWING_INVOICE_PDF',
  VIEW_INVOICE_PDF_SUCCESS: 'VIEW_INVOICE_PDF_SUCCESS',
  VIEW_INVOICE_PDF_FAILED: 'VIEW_INVOICE_PDF_FAILED',

  VIEW_VAT_REVERSAL_ATTACHMENT: 'VIEW_VAT_REVERSAL_ATTACHMENT',
  VIEWING_VAT_REVERSAL_ATTACHMENT: 'VIEWING_VAT_REVERSAL_ATTACHMENT',
  VIEW_VAT_REVERSAL_ATTACHMENT_SUCCESS: 'VIEW_VAT_REVERSAL_ATTACHMENT_SUCCESS',
  VIEW_VAT_REVERSAL_ATTACHMENT_FAILED: 'VIEW_VAT_REVERSAL_ATTACHMENT_FAILED',

  VIEW_PAYMENT_PROOF_PDF: 'VIEW_PAYMENT_PROOF_PDF',
  VIEWING_PAYMENT_PROOF_PDF: 'VIEWING_PAYMENT_PROOF_PDF',
  VIEW_PAYMENT_PROOF_PDF_SUCCESS: 'VIEW_PAYMENT_PROOF_PDF_SUCCESS',
  VIEW_PAYMENT_PROOF_PDF_FAILED: 'VIEW_PAYMENT_PROOF_PDF_FAILED',

  REQUEST_INVOICE_APPROVAL: 'REQUEST_INVOICE_APPROVAL',
  REQUESTING_INVOICE_APPROVAL: 'REQUESTING_INVOICE_APPROVAL',
  REQUEST_INVOICE_APPROVAL_SUCCESS: 'REQUEST_INVOICE_APPROVAL_SUCCESS',
  REQUEST_INVOICE_APPROVAL_FAILED: 'REQUEST_INVOICE_APPROVAL_FAILED',

  REQUEST_VAT_EXEMPT_REVERSAL: 'REQUEST_VAT_EXEMPT_REVERSAL',
  REQUESTING_VAT_EXEMPT_REVERSAL: 'REQUESTING_VAT_EXEMPT_REVERSAL',
  REQUEST_VAT_EXEMPT_REVERSAL_SUCCESS: 'REQUEST_VAT_EXEMPT_REVERSAL_SUCCESS',
  REQUEST_VAT_EXEMPT_REVERSAL_FAILED: 'REQUEST_VAT_EXEMPT_REVERSAL_FAILED',

  APPROVE_VAT_EXEMPT_REVERSAL: 'APPROVE_VAT_EXEMPT_REVERSAL',
  APPROVING_VAT_EXEMPT_REVERSAL: 'APPROVING_VAT_EXEMPT_REVERSAL',
  APPROVE_VAT_EXEMPT_REVERSAL_SUCCESS: 'APPROVE_VAT_EXEMPT_REVERSAL_SUCCESS',
  APPROVE_VAT_EXEMPT_REVERSAL_FAILED: 'APPROVE_VAT_EXEMPT_REVERSAL_FAILED',

  REJECT_VAT_EXEMPT_REVERSAL: 'REJECT_VAT_EXEMPT_REVERSAL',
  REJECTING_VAT_EXEMPT_REVERSAL: 'REJECTING_VAT_EXEMPT_REVERSAL',
  REJECT_VAT_EXEMPT_REVERSAL_SUCCESS: 'REJECT_VAT_EXEMPT_REVERSAL_SUCCESS',
  REJECT_VAT_EXEMPT_REVERSAL_FAILED: 'REJECT_VAT_EXEMPT_REVERSAL_FAILED',
  
  FETCH_REVERSAL_REQUEST_BY_ID: 'FETCH_REVERSAL_REQUEST_BY_ID',
  FETCHING_REVERSAL_REQUEST_BY_ID: 'FETCHING_REVERSAL_REQUEST_BY_ID',
  FETCH_REVERSAL_REQUEST_BY_ID_SUCCESS: 'FETCH_REVERSAL_REQUEST_BY_ID_SUCCESS',
  FETCH_REVERSAL_REQUEST_BY_ID_FAILED: 'FETCH_REVERSAL_REQUEST_BY_ID_FAILED',

  FETCH_ALL_FINANCE_USERS: 'FETCH_ALL_FINANCE_USERS',
  FETCHING_ALL_FINANCE_USERS: 'FETCHING_ALL_FINANCE_USERS',
  FETCH_ALL_FINANCE_USERS_SUCCESS: 'FETCH_ALL_FINANCE_USERS_SUCCESS',
  FETCH_ALL_FINANCE_USERS_FAILED: 'FETCH_ALL_FINANCE_USERS_FAILED',

  STORE_ESIGNATURE: 'STORE_ESIGNATURE',
  STORING_ESIGNATURE: 'STORING_ESIGNATURE',
  STORE_ESIGNATURE_SUCCESS: 'STORE_ESIGNATURE_SUCCESS',
  STORE_ESIGNATURE_FAILED: 'STORE_ESIGNATURE_FAILED',

  REJECT_INVOICE: 'REJECT_INVOICE',
  REJECTING_INVOICE: 'REJECTING_INVOICE',
  REJECT_INVOICE_SUCCESS: 'REJECT_INVOICE_SUCCESS',
  REJECT_INVOICE_FAILED: 'REJECT_INVOICE_FAILED',

  APPROVE_INVOICE: 'APPROVE_INVOICE',
  APPROVING_INVOICE: 'APPROVING_INVOICE',
  APPROVE_INVOICE_SUCCESS: 'APPROVE_INVOICE_SUCCESS',
  APPROVE_INVOICE_FAILED: 'APPROVE_INVOICE_FAILED',

  STORE_VAT_REVERSAL_ATTACHMENT: 'STORE_VAT_REVERSAL_ATTACHMENT',
  STORING_VAT_REVERSAL_ATTACHMENT: 'STORING_VAT_REVERSAL_ATTACHMENT',
  STORE_VAT_REVERSAL_ATTACHMENT_SUCCESS: 'STORE_VAT_REVERSAL_ATTACHMENT_SUCCESS',
  STORE_VAT_REVERSAL_ATTACHMENT_FAILED: 'STORE_VAT_REVERSAL_ATTACHMENT_FAILED',

  STORE_PAYMENT_PROOF_FOR_UPLOAD: 'STORE_PAYMENT_PROOF_FOR_UPLOAD',
  STORING_PAYMENT_PROOF_FOR_UPLOAD: 'STORING_PAYMENT_PROOF_FOR_UPLOAD',
  STORE_PAYMENT_PROOF_FOR_UPLOAD_SUCCESS: 'STORE_PAYMENT_PROOF_FOR_UPLOAD_SUCCESS',
  STORE_PAYMENT_PROOF_FOR_UPLOAD_FAILED: 'STORE_PAYMENT_PROOF_FOR_UPLOAD_FAILED',

  MANAGE_PAYMENT_PROOF_FILES: 'MANAGE_PAYMENT_PROOF_FILES',
  MANAGING_PAYMENT_PROOF_FILES: 'MANAGING_PAYMENT_PROOF_FILES',
  MANAGE_PAYMENT_PROOF_FILES_SUCCESS: 'MANAGE_PAYMENT_PROOF_FILES_SUCCESS',
  MANAGE_PAYMENT_PROOF_FILES_FAILED: 'MANAGE_PAYMENT_PROOF_FILES_FAILED',

  SEND_MERCHANT_INVOICE: 'SEND_MERCHANT_INVOICE',
  SENDING_MERCHANT_INVOICE: 'SENDING_MERCHANT_INVOICE',
  SEND_MERCHANT_INVOICE_SUCCESS: 'SEND_MERCHANT_INVOICE_SUCCESS',
  SEND_MERCHANT_INVOICE_FAILED: 'SEND_MERCHANT_INVOICE_FAILED',

  FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA:
    'FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA',
  FETCHING_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA:
    'FETCHING_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA',
  FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS:
    'FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS',
  FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED:
    'FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED',

  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOAD_SUMMARY_REPORT',
  DOWNLOADING_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOADING_SUMMARY_REPORT',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS: 'DOWNLOAD_SUMMARY_REPORT_SUCCESS',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED: 'DOWNLOAD_SUMMARY_REPORT_FAILED',

  FETCH_ALL_SETTLEMENT_CYCLE: 'FETCH_ALL_SETTLEMENT_CYCLE',
  FETCHING_ALL_SETTLEMENT_CYCLE: 'FETCHING_ALL_SETTLEMENT_CYCLE',
  FETCH_ALL_SETTLEMENT_CYCLE_SUCCESS: 'FETCH_ALL_SETTLEMENT_CYCLE_SUCCESS',
  FETCH_ALL_SETTLEMENT_CYCLE_FAILED: 'FETCH_ALL_SETTLEMENT_CYCLE_FAILED',
  LOADING_MORE_SETTLEMENT_CYCLE: 'LOADING_MORE_SETTLEMENT_CYCLE',

  FETCH_SETTLEMENT_CYCLE_BY_ID: 'FETCH_SETTLEMENT_CYCLE_BY_ID',
  FETCHING_SETTLEMENT_CYCLE_BY_ID: 'FETCHING_SETTLEMENT_CYCLE_BY_ID',
  FETCH_SETTLEMENT_CYCLE_BY_ID_SUCCESS: 'FETCH_SETTLEMENT_CYCLE_BY_ID_SUCCESS',
  FETCH_SETTLEMENT_CYCLE_BY_ID_FAILED: 'FETCH_SETTLEMENT_CYCLE_BY_ID_FAILED',
  RESET_ACTIVE_SETTLEMENT_CYCLE_BY_ID: 'RESET_ACTIVE_SETTLEMENT_CYCLE_BY_ID',

  FETCH_SETTLEMENT_RATE_BY_ID: 'FETCH_SETTLEMENT_RATE_BY_ID',
  FETCHING_SETTLEMENT_RATE_BY_ID: 'FETCHING_SETTLEMENT_RATE_BY_ID',
  FETCH_SETTLEMENT_RATE_BY_ID_SUCCESS: 'FETCH_SETTLEMENT_RATE_BY_ID_SUCCESS',
  FETCH_SETTLEMENT_RATE_BY_ID_FAILED: 'FETCH_SETTLEMENT_RATE_BY_ID_FAILED',
  RESET_ACTIVE_SETTLEMENT_RATE_BY_ID: 'RESET_ACTIVE_SETTLEMENT_RATE_BY_ID',

  ADD_SETTLEMENT_CYCLE: 'ADD_SETTLEMENT_CYCLE',
  ADDING_SETTLEMENT_CYCLE: 'ADDING_SETTLEMENT_CYCLE',
  ADD_SETTLEMENT_CYCLE_SUCCESS: 'ADD_SETTLEMENT_CYCLE_SUCCESS',
  ADD_SETTLEMENT_CYCLE_FAILED: 'ADD_SETTLEMENT_CYCLE_FAILED',

  FETCH_ALL_BILLING_ADDITIONAL_FEE: 'FETCH_ALL_BILLING_ADDITIONAL_FEE',
  FETCHING_ALL_BILLING_ADDITIONAL_FEE: 'FETCHING_ALL_BILLING_ADDITIONAL_FEE',
  FETCH_ALL_BILLING_ADDITIONAL_FEE_SUCCESS: 'FETCH_ALL_BILLING_ADDITIONAL_FEE_SUCCESS',
  FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED: 'FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED',
  LOADING_MORE_BILLING_ADDITIONAL_FEE: 'LOADING_MORE_BILLING_ADDITIONAL_FEE',

  FETCH_BILLING_ADDITIONAL_FEE_BY_ID: 'FETCH_BILLING_ADDITIONAL_FEE_BY_ID',
  FETCHING_BILLING_ADDITIONAL_FEE_BY_ID: 'FETCHING_BILLING_ADDITIONAL_FEE_BY_ID',
  FETCH_BILLING_ADDITIONAL_FEE_BY_ID_SUCCESS: 'FETCH_BILLING_ADDITIONAL_FEE_BY_ID_SUCCESS',
  FETCH_BILLING_ADDITIONAL_FEE_BY_ID_FAILED: 'FETCH_BILLING_ADDITIONAL_FEE_BY_ID_FAILED',
  RESET_ACTIVE_BILLING_ADDITIONAL_FEE_BY_ID: 'RESET_ACTIVE_BILLING_ADDITIONAL_FEE_BY_ID',

  CREATE_BILLING_ADDITIONAL_FEE: 'CREATE_BILLING_ADDITIONAL_FEE',
  CREATING_BILLING_ADDITIONAL_FEE: 'CREATING_BILLING_ADDITIONAL_FEE',
  CREATE_BILLING_ADDITIONAL_FEE_SUCCESS: 'CREATE_BILLING_ADDITIONAL_FEE_SUCCESS',
  CREATE_BILLING_ADDITIONAL_FEE_FAILED: 'CREATE_BILLING_ADDITIONAL_FEE_FAILED',

  UPDATE_BILLING_ADDITIONAL_FEE: 'UPDATE_BILLING_ADDITIONAL_FEE',
  UPDATING_BILLING_ADDITIONAL_FEE: 'UPDATING_BILLING_ADDITIONAL_FEE',
  UPDATE_BILLING_ADDITIONAL_FEE_SUCCESS: 'UPDATE_BILLING_ADDITIONAL_FEE_SUCCESS',
  UPDATE_BILLING_ADDITIONAL_FEE_FAILED: 'UPDATE_BILLING_ADDITIONAL_FEE_FAILED',

  FETCH_BILLING_CONFIGURATION_LOGS: 'FETCH_BILLING_CONFIGURATION_LOGS',
  LOADING_MORE_BILLING_CONFIGURATION_LOGS: 'LOADING_MORE_BILLING_CONFIGURATION_LOGS',
  FETCHING_BILLING_CONFIGURATION_LOGS: 'FETCHING_BILLING_CONFIGURATION_LOGS',
  FETCH_BILLING_CONFIGURATION_LOGS_SUCCESS: 'FETCH_BILLING_CONFIGURATION_LOGS_SUCCESS',
  FETCH_BILLING_CONFIGURATION_LOGS_FAILED: 'FETCH_BILLING_CONFIGURATION_LOGS_FAILED',
  RESET_BILLING_CONFIGURATION_LOGS: 'RESET_BILLING_CONFIGURATION_LOGS',

  EDIT_SETTLEMENT_CYCLE: 'EDIT_SETTLEMENT_CYCLE',
  EDITING_SETTLEMENT_CYCLE: 'EDITING_SETTLEMENT_CYCLE',
  EDIT_SETTLEMENT_CYCLE_SUCCESS: 'EDIT_SETTLEMENT_CYCLE_SUCCESS',
  EDIT_SETTLEMENT_CYCLE_FAILED: 'EDIT_SETTLEMENT_CYCLE_FAILED',

  GENERATE_SUMMARY_BREAKDOWN_REPORT: 'GENERATE_SUMMARY_BREAKDOWN_REPORT',
  GENERATING_SUMMARY_BREAKDOWN_REPORT: 'GENERATING_SUMMARY_BREAKDOWN_REPORT',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_SUCCESS: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_SUCCESS',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED',

  GENERATE_SUMMARY_BREAKDOWN_REPORT_V2: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_V2',
  GENERATING_SUMMARY_BREAKDOWN_REPORT_V2: 'GENERATING_SUMMARY_BREAKDOWN_REPORT_V2',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_SUCCESS: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_SUCCESS',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED',

  DONE_PARSING_LEADS_FILE_DATA: 'DONE_PARSING_LEADS_FILE_DATA',

  EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT: 'EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT',
  EDITING_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT: 'EDITING_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT',
  EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_SUCCESS:
    'EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_SUCCESS',
  EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED:
    'EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED',

  STORE_ADDENDUM_FOR_UPLOAD: 'STORE_ADDENDUM_FOR_UPLOAD',
  STORING_ADDENDUM_FOR_UPLOAD: 'STORING_ADDENDUM_FOR_UPLOAD',
  STORE_ADDENDUM_FOR_UPLOAD_SUCCESS: 'STORE_ADDENDUM_FOR_UPLOAD_SUCCESS',
  STORE_ADDENDUM_FOR_UPLOAD_FAILED: 'STORE_ADDENDUM_FOR_UPLOAD_FAILED',
  RESET_ADDENDUM_FOR_UPLOAD: 'RESET_ADDENDUM_FOR_UPLOAD',

  CREATE_CHANGE_REQUEST_RATES: 'CREATE_CHANGE_REQUEST_RATES',
  CREATING_CHANGE_REQUEST_RATES: 'CREATING_CHANGE_REQUEST_RATES',
  CREATE_CHANGE_REQUEST_RATES_SUCCESS: 'CREATE_CHANGE_REQUEST_RATES_SUCCESS',
  CREATE_CHANGE_REQUEST_RATES_FAILED: 'CREATE_CHANGE_REQUEST_RATES_FAILED',

  REJECT_CHANGE_REQUEST_RATES: 'REJECT_CHANGE_REQUEST_RATES',
  REJECTING_CHANGE_REQUEST_RATES: 'REJECTING_CHANGE_REQUEST_RATES',
  REJECT_CHANGE_REQUEST_RATES_SUCCESS: 'REJECT_CHANGE_REQUEST_RATES_SUCCESS',
  REJECT_CHANGE_REQUEST_RATES_FAILED: 'REJECT_CHANGE_REQUEST_RATES_FAILED',

  APPROVE_CHANGE_REQUEST_RATES_BY_SALES: 'APPROVE_CHANGE_REQUEST_RATES_BY_SALES',
  APPROVING_CHANGE_REQUEST_RATES_BY_SALES: 'APPROVING_CHANGE_REQUEST_RATES_BY_SALES',
  APPROVE_CHANGE_REQUEST_RATES_BY_SALES_SUCCESS: 'APPROVE_CHANGE_REQUEST_RATES_BY_SALES_SUCCESS',
  APPROVE_CHANGE_REQUEST_RATES_BY_SALES_FAILED: 'APPROVE_CHANGE_REQUEST_RATES_BY_SALES_FAILED',

  APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE: 'APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE',
  APPROVING_CHANGE_REQUEST_RATES_BY_FINANCE: 'APPROVING_CHANGE_REQUEST_RATES_BY_FINANCE',
  APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_SUCCESS:
    'APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_SUCCESS',
  APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_FAILED: 'APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_FAILED',

  DOWNLOAD_ADDENDUM_DOCUMENT: 'DOWNLOAD_ADDENDUM_DOCUMENT',
  DOWNLOADING_ADDENDUM_DOCUMENT: 'DOWNLOADING_ADDENDUM_DOCUMENT',
  DOWNLOAD_ADDENDUM_DOCUMENT_SUCCESS: 'DOWNLOAD_ADDENDUM_DOCUMENT_SUCCESS',
  DOWNLOAD_ADDENDUM_DOCUMENT_FAILED: 'DOWNLOAD_ADDENDUM_DOCUMENT_FAILED',

  FETCH_FEE_HISTORY: 'FETCH_FEE_HISTORY',
  LOADING_MORE_FEE_HISTORY: 'LOADING_MORE_FEE_HISTORY',
  FETCHING_FEE_HISTORY: 'FETCHING_FEE_HISTORY',
  FETCH_FEE_HISTORY_SUCCESS: 'FETCH_FEE_HISTORY_SUCCESS',
  FETCH_FEE_HISTORY_FAILED: 'FETCH_FEE_HISTORY_FAILED',
  RESET_FEE_HISTORY: 'RESET_FEE_HISTORY',

  SET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER: 'SET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER',
  RESET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER: 'RESET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER',

  RESET_GENERATED_MONTHLY_RECONCILED_FILTER: 'RESET_GENERATED_MONTHLY_RECONCILED_FILTER',

  SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER: 'SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER',
  SAVING_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER:
    'SAVING_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER',
  SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_SUCCESS:
    'SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_SUCCESS',
  SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED:
    'SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED',

  FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER: 'FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER',
  FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED:
    'FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED',

  CLEAR_PRESIGNED_ESIGNATURE: 'CLEAR_PRESIGNED_ESIGNATURE',

  TAG_AS_FLOATING: 'TAG_AS_FLOATING',
  TAGGING_AS_FLOATING: 'TAGGING_AS_FLOATING',
  TAG_AS_FLOATING_SUCCESS: 'TAG_AS_FLOATING_SUCCESS',
  TAG_AS_FLOATING_FAILED: 'TAG_AS_FLOATING_FAILED',

  FIND_SINGLE_TRANSACTION_LOOSELY: 'FIND_SINGLE_TRANSACTION_LOOSELY',
  FINDING_SINGLE_TRANSACTION_LOOSELY: 'FINDING_SINGLE_TRANSACTION_LOOSELY',
  FIND_SINGLE_TRANSACTION_LOOSELY_SUCCESS: 'FIND_SINGLE_TRANSACTION_LOOSELY_SUCCESS',
  FIND_SINGLE_TRANSACTION_LOOSELY_FAILED: 'FIND_SINGLE_TRANSACTION_LOOSELY_FAILED',

  STORE_RECON_PROOF_FOR_UPLOAD: 'STORE_RECON_PROOF_FOR_UPLOAD',
  STORING_RECON_PROOF_FOR_UPLOAD: 'STORING_RECON_PROOF_FOR_UPLOAD',
  STORE_RECON_PROOF_FOR_UPLOAD_SUCCESS: 'STORE_RECON_PROOF_FOR_UPLOAD_SUCCESS',
  STORE_RECON_PROOF_FOR_UPLOAD_FAILED: 'STORE_RECON_PROOF_FOR_UPLOAD_FAILED',

  CONFIRM_MANUAL_RECON: 'CONFIRM_MANUAL_RECON',
  CONFIRMING_MANUAL_RECON: 'CONFIRMING_MANUAL_RECON',
  CONFIRM_MANUAL_RECON_SUCCESS: 'CONFIRM_MANUAL_RECON_SUCCESS',
  CONFIRM_MANUAL_RECON_FAILED: 'CONFIRM_MANUAL_RECON_FAILED',

  DOWNLOAD_MANUAL_RECON_PROOF: 'DOWNLOAD_MANUAL_RECON_PROOF',
  DOWNLOADING_MANUAL_RECON_PROOF: 'DOWNLOADING_MANUAL_RECON_PROOF',
  DOWNLOAD_MANUAL_RECON_PROOF_SUCCESS: 'DOWNLOAD_MANUAL_RECON_PROOF_SUCCESS',
  DOWNLOAD_MANUAL_RECON_PROOF_FAILED: 'DOWNLOAD_MANUAL_RECON_PROOF_FAILED',

  EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS: 'EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS',
  EDITING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS: 'EDITING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS',
  EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_SUCCESS:
    'EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_SUCCESS',
  EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED:
    'EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED',

  CREATE_TRANSACTION_DELETION_REQUEST: 'CREATE_TRANSACTION_DELETION_REQUEST',
  CREATING_TRANSACTION_DELETION_REQUEST: 'CREATING_TRANSACTION_DELETION_REQUEST',
  CREATE_TRANSACTION_DELETION_REQUEST_SUCCESS: 'CREATE_TRANSACTION_DELETION_REQUEST_SUCCESS',
  CREATE_TRANSACTION_DELETION_REQUEST_FAILED: 'CREATE_TRANSACTION_DELETION_REQUEST_FAILED',

  FETCH_TRANSACTION_REQUESTS: 'FETCH_TRANSACTION_REQUESTS',
  FETCHING_TRANSACTION_REQUESTS: 'FETCHING_TRANSACTION_REQUESTS',
  FETCH_TRANSACTION_REQUESTS_SUCCESS: 'FETCH_TRANSACTION_REQUESTS_SUCCESS',
  FETCH_TRANSACTION_REQUESTS_FAILED: 'FETCH_TRANSACTION_REQUESTS_FAILED',

  UPDATE_TRANSACTION_REQUEST_STATUS: 'UPDATE_TRANSACTION_REQUEST_STATUS',
  UPDATING_TRANSACTION_REQUEST_STATUS: 'UPDATING_TRANSACTION_REQUEST_STATUS',
  UPDATE_TRANSACTION_REQUEST_STATUS_SUCCESS: 'UPDATE_TRANSACTION_REQUEST_STATUS_SUCCESS',
  UPDATE_TRANSACTION_REQUEST_STATUS_FAILED: 'UPDATE_TRANSACTION_REQUEST_STATUS_FAILED',

  CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST: 'CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST',
  CREATING_CATEGORIZE_FLOATING_TRANSACTION_REQUEST:
    'CREATING_CATEGORIZE_FLOATING_TRANSACTION_REQUEST',
  CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_SUCCESS:
    'CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_SUCCESS',
  CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED:
    'CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED',

  CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST:
    'CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST',
  CREATING_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST:
    'CREATING_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST',
  CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_SUCCESS:
    'CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_SUCCESS',
  CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED:
    'CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED',

  TAG_RECONCILED_TRANSACTION: 'TAG_RECONCILED_TRANSACTION',
  TAGGING_RECONCILED_TRANSACTION: 'TAGGING_RECONCILED_TRANSACTION',
  TAG_RECONCILED_TRANSACTION_SUCCESS: 'TAG_RECONCILED_TRANSACTION_SUCCESS',
  TAG_RECONCILED_TRANSACTION_FAILED: 'TAG_RECONCILED_TRANSACTION_FAILED',

  TAG_UNMATCHED_AS_ENDORSED: 'TAG_UNMATCHED_AS_ENDORSED',
  TAGGING_UNMATCHED_AS_ENDORSED: 'TAGGING_UNMATCHED_AS_ENDORSED',
  TAG_UNMATCHED_AS_ENDORSED_SUCCESS: 'TAG_UNMATCHED_AS_ENDORSED_SUCCESS',
  TAG_UNMATCHED_AS_ENDORSED_FAILED: 'TAG_UNMATCHED_AS_ENDORSED_FAILED',

  FETCH_ALL_APPROVED_FILTERED_DATE: 'FETCH_ALL_APPROVED_FILTERED_DATE',
  FETCHING_ALL_APPROVED_FILTERED_DATE: 'FETCHING_ALL_APPROVED_FILTERED_DATE',
  FETCH_ALL_APPROVED_FILTERED_DATE_SUCCESS: 'FETCH_ALL_APPROVED_FILTERED_DATE_SUCCESS',
  FETCH_ALL_APPROVED_FILTERED_DATE_FAILED: 'FETCH_ALL_APPROVED_FILTERED_DATE_FAILED',

  //[Across Payment Channels]
  NOTIFY_UNRECONCILED_TRANSACTIONS: 'NOTIFY_UNRECONCILED_TRANSACTIONS',
  NOTIFYING_UNRECONCILED_TRANSACTIONS: 'NOTIFYING_UNRECONCILED_TRANSACTIONS',
  NOTIFY_UNRECONCILED_TRANSACTIONS_SUCCESS: 'NOTIFY_UNRECONCILED_TRANSACTIONS_SUCCESS',
  NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED: 'NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED',

  FETCH_APPROVED_FILTERED_DATE_DETAILS: 'FETCH_APPROVED_FILTERED_DATE_DETAILS',
  FETCHING_APPROVED_FILTERED_DATE_DETAILS: 'FETCHING_APPROVED_FILTERED_DATE_DETAILS',
  FETCH_APPROVED_FILTERED_DATE_DETAILS_SUCCESS: 'FETCH_APPROVED_FILTERED_DATE_DETAILS_SUCCESS',
  FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED: 'FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED',

  FETCH_UNRECONCILED_PTI_GROUP_MERCHANT: 'FETCH_UNRECONCILED_PTI_GROUP_MERCHANT',
  FETCHING_UNRECONCILED_PTI_GROUP_MERCHANT: 'FETCHING_UNRECONCILED_PTI_GROUP_MERCHANT',
  FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_SUCCESS: 'FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_SUCCESS',
  FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED: 'FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED',

  GENERATE_SUMMARY_RECONCILIATION_REPORT: 'GENERATE_SUMMARY_RECONCILIATION_REPORT',
  GENERATING_SUMMARY_RECONCILIATION_REPORT: 'GENERATING_SUMMARY_RECONCILIATION_REPORT',
  GENERATE_SUMMARY_RECONCILIATION_REPORT_SUCCESS: 'GENERATE_SUMMARY_RECONCILIATION_REPORT_SUCCESS',
  GENERATE_SUMMARY_RECONCILIATION_REPORT_FAILED: 'GENERATE_SUMMARY_RECONCILIATION_REPORT_FAILED',

  DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT: 'DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT',
  DOWNLOADING_GENERATED_SUMMARY_RECONCILIATION_REPORT:
    'DOWNLOADING_GENERATED_SUMMARY_RECONCILIATION_REPORT',
  DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_SUCCESS:
    'DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_SUCCESS',
  DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_FAILED:
    'DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_FAILED',

  FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES:
    'FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES',
  FETCHING_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES:
    'FETCHING_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES',
  FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_SUCCESS:
    'FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_SUCCESS',
  FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_FAILED:
    'FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_FAILED',

  DOWNLOAD_UPLOADED_BANK_FILE: 'DOWNLOAD_UPLOADED_BANK_FILE',
  DOWNLOADING_UPLOADED_BANK_FILE: 'DOWNLOADING_UPLOADED_BANK_FILE',
  DOWNLOAD_UPLOADED_BANK_FILE_SUCCESS: 'DOWNLOAD_UPLOADED_BANK_FILE_SUCCESS',
  DOWNLOAD_UPLOADED_BANK_FILE_FAILED: 'DOWNLOAD_UPLOADED_BANK_FILE_FAILED',

  clearPresignedEsignature: () => ({
    type: actions.CLEAR_PRESIGNED_ESIGNATURE
  }),

  resetParseDataNotifier: () => ({
    type: actions.RESET_PARSE_DATA_FILE_NOTIFIER
  }),
  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),
  fetchCaseLogs: (payload, pagination) => ({
    type: actions.FETCH_CASE_LOGS,
    payload,
    pagination
  }),
  updateCaseDetails: (payload, id) => ({
    type: actions.UPDATE_CASE_DETAILS,
    payload,
    id
  }),
  unsubscribeNotificationCredential: (payload, id) => ({
    type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL,
    payload,
    id
  }),
  unsubscribeClearMessage: () => ({
    type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_CLEAR_MESSAGE
  }),
  messageArrived: payload => ({
    type: actions.MQTT_TRX,
    payload: payload
  }),
  getS3UrlsForCaseFiles: (key, files) => ({
    type: actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD,
    key,
    files
  }),
  sendDiscussion: (urls, payload) => ({
    type: actions.SEND_DISCUSSION_ITEM,
    urls,
    payload
  }),
  likeDiscussion: (id, payload) => ({
    type: actions.LIKE_DISCUSSION_DATA,
    id,
    payload
  }),
  fetchCaseDiscussions: (payload, currentList) => ({
    type: actions.FETCH_CASE_DISCUSSIONS,
    payload,
    currentList
  }),
  fetchReconciliationDataByPChannelID: payload => ({
    type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL,
    payload
  }),
  fetchBillingDataByMerchantID: payload => ({
    type: actions.FETCH_BILLING_DATA_BY_MERCHANT,
    payload
  }),
  fetchResponseCode: payload => ({
    type: actions.FETCH_RESPONSE_CODE,
    payload
  }),
  addNewResponseCode: payload => ({
    type: actions.ADD_RESPONSE_CODE,
    payload
  }),
  editResponseCode: (payload, id) => ({
    type: actions.EDIT_RESPONSE_CODE,
    payload,
    id
  }),
  editSettlementRate: (payload, id) => ({
    type: actions.EDIT_SETTLEMENT_RATE,
    payload,
    id
  }),
  changeResponseCodeStatus: (payload, id) => ({
    type: actions.CHANGE_STATUS_RESPONSE_CODE,
    payload,
    id
  }),
  fetchSecurityCode: payload => ({
    type: actions.FETCH_SECURITY_CODE,
    payload
  }),
  addNewSecurityCode: payload => ({
    type: actions.ADD_SECURITY_CODE,
    payload
  }),
  editSecurityCode: (payload, id) => ({
    type: actions.EDIT_SECURITY_CODE,
    payload,
    id
  }),
  changeSecurityCodeStatus: (payload, id) => ({
    type: actions.CHANGE_STATUS_SECURITY_CODE,
    payload,
    id
  }),
  fetchCaseDetails: payload => ({
    type: actions.FETCH_CASE_DETAILS_DATA,
    payload
  }),
  resetCaseDetails: payload => ({
    type: actions.RESET_CASE_DETAILS,
    payload
  }),
  inviteCaseMember: payload => ({
    type: actions.INVITE_CASE_MEMBER,
    payload
  }),
  fetchBillingDetails: payload => ({
    type: actions.FETCH_BILLING_DETAILS,
    payload
  }),
  fetchBillerDetails: payload => ({
    type: actions.FETCH_BILLER_DETAILS,
    payload
  }),
  fetchCollatedData: payload => ({
    type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL,
    payload
  }),
  resetReconciliationDataByPChannelID: payload => ({
    type: actions.RESET_RECONCILIATION_DATA_BY_PCHANNEL,
    payload
  }),
  resetCollatedData: payload => ({
    type: actions.RESET_COLLATED_DATA_BY_PCHANNEL,
    payload
  }),
  resetSettlementReportData: payload => ({
    type: actions.RESET_SETTLEMENT_REPORT,
    payload
  }),
  resetBillingDataByMerchantID: payload => ({
    type: actions.RESET_BILLING_DATA_BY_MERCHANT,
    payload
  }),
  addBillingDataByMerchantID: payload => ({
    type: actions.ADD_BILLING_DATA_BY_MERCHANT_ID,
    payload
  }),
  analyzeCollateTransaction: payload => ({
    type: actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA,
    payload
  }),
  generateReportData: payload => ({
    type: actions.GENERATE_REPORT_DATA,
    payload
  }),
  downloadSettlementReportData: payload => ({
    type: actions.DOWNLOAD_SETTLEMENT_REPORT_DATA,
    payload
  }),
  generateMonthReportData: payload => ({
    type: actions.GENERATE_MONTH_REPORT_DATA,
    payload
  }),
  downloadCaseAttachment: payload => ({
    type: actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT,
    payload
  }),
  generateUnreconciledReportData: payload => ({
    type: actions.GENERATE_UNRECONCILED_REPORT_DATA,
    payload
  }),
  downloadUnreconciledReportData: payload => ({
    type: actions.DOWNLOAD_UNRECONCILED_REPORT_DATA,
    payload
  }),
  checkCollateTransactionFromDev: payload => ({
    type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV,
    payload
  }),
  checkCollateTransactionFromPaygate: payload => ({
    type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE,
    payload
  }),
  fetchSettlementReportData: (payload, pagination) => ({
    type: actions.FETCH_SETTLEMENT_REPORT,
    payload,
    pagination
  }),
  fetchAllMonthSettlementReportData: (payload, pagination) => ({
    type: actions.FETCH_MONTH_SETTLEMENT_REPORT,
    payload,
    pagination
  }),
  fetchUnreconciledReportData: (payload, pagination) => ({
    type: actions.FETCH_UNRECONCILED_REPORT_LIST,
    payload,
    pagination
  }),
  fetchFinanceDashboardData: (payload) => ({
    type: actions.FETCH_FINANCE_DASHBOARD_DATA,
    payload
  }),
  checkCollateTransaction: payload => ({
    type: actions.CHECK_COLLATE_DATA,
    payload
  }),
  fetchAllReconciledData: (payload, pagination) => ({
    type: actions.FETCH_ALL_RECONCILED_DATA,
    payload,
    pagination
  }),
  escalateTransactionData: payload => ({
    type: actions.ESCALATE_TRANSACTION_DATA,
    payload
  }),
  fetchAllCases: (payload, currentList) => ({
    type: actions.FETCH_CASE_TRANSACTION_DATA,
    payload,
    currentList
  }),
  fetchUploadedBankFiles: (payload, pagination) => ({
    type: actions.FETCH_UPLOADED_BANK_FILES,
    payload,
    pagination
  }),
  fetchUploadedBankTransaction: (id, payload, pagination) => ({
    type: actions.FETCH_UPLOADED_BANK_TRANSACTION,
    id,
    payload,
    pagination
  }),
  updateBankRemittance: payload => ({
    type: actions.UPDATE_BANK_REMITTANCE,
    payload
  }),
  updateBankTransaction: payload => ({
    type: actions.UPDATE_BANK_TRANSACTION,
    payload
  }),
  updateBankFile: (id, payload) => ({
    type: actions.UPDATE_BANK_FILE,
    id,
    payload
  }),
  generateBankTrxStatistics: (id, payload) => ({
    type: actions.GENERATE_BANK_TRANSACTION_STATISTICS,
    id,
    payload
  }),
  fetchAllChannelSchedule: payload => ({
    type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE,
    payload
  }),
  addChannelSchedule: payload => ({
    type: actions.ADD_REMITTING_CHANNEL_SCHEDULE,
    payload
  }),
  editChannelSchedule: (id, payload) => ({
    type: actions.EDIT_REMITTING_CHANNEL_SCHEDULE,
    id,
    payload
  }),
  setActiveChannelSchedule: payload => ({
    type: actions.SET_ACTIVE_CHANNEL_SCHEDULE,
    payload
  }),
  setPnxBankColumn: payload => ({
    type: actions.SET_PNX_BANK_COLUMN,
    payload
  }),
  deleteUploadedBankFileAndTransactions: id => ({
    type: actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS,
    id
  }),
  getTrxList: payload => ({
    type: actions.FETCH_TRANSACTION_LIST,
    payload: payload
  }),
  resetTransactionList: () => ({
    type: actions.FETCH_TRANSACTION_LIST_RESET
  }),
  resetTrxList: () => ({
    type: actions.RESET_TRANSACTION_LIST
  }),
  setIsFiltered: () => ({
    type: actions.SET_IS_FILTERED
  }),
  getTrxDetails: payload => ({
    type: actions.FETCH_TRANSACTION_DETAILS,
    payload: payload
  }),
  resetTrxDetails: () => ({
    type: actions.RESET_TRANSACTION_DETAILS
  }),
  fetchOtcTransactions: payload => ({
    type: actions.FETCH_OTC_TRANSACTIONS,
    payload
  }),
  updateOtcTransactions: payload => ({
    type: actions.UPDATE_OTC_TRANSACTIONS,
    payload
  }),
  downloadCsv: payload => ({
    type: actions.DOWNLOAD_CSV,
    payload: payload
  }),
  clearDownloadCsv: () => ({
    type: actions.CLEAR_DOWNLOAD_CSV
  }),
  resetDownloadStatus: () => ({
    type: actions.DOWNLOAD_STATUS,
    payload: null
  }),
  getExcelDownloadList: payload => ({
    type: actions.FETCH_EXCEL_DOWNLOAD_LIST,
    payload: payload
  }),
  getPreviousDownloads: payload => ({
    type: actions.FETCH_PREVIOUS_DOWNLOADS,
    payload: payload
  }),
  fetchMerchants: () => ({
    type: actions.FETCH_MERCHANTS
  }),
  getCustomMerchantParams: (payload) => ({
    type: actions.FETCH_CUSTOM_MERCHANT_PARAMS,
    payload
  }),

  resetGetCustomMerchantParams: () => ({
    type: actions.FETCH_CUSTOM_MERCHANT_PARAMS_RESET,
  }),
  fetchDownloadReport: payload => ({
    type: actions.FETCH_DOWNLOAD_REPORT,
    payload: payload
  }),

  fetchAllFinanceOperations: (payload, currentList) => ({
    type: actions.FETCH_ALL_FINANCE_OPERATIONS,
    payload,
    currentList
  }),

  fetchFinanceOperationsByID: payload => ({
    type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
    payload
  }),

  fetchFinanceOperationsLogs: (payload, pagination) => ({
    type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
    payload,
    pagination
  }),

  downloadVatExemptionFileOperations: (payload, id) => ({
    type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE,
    payload,
    id
  }),

  downloadPaymentProofFileOperations: (payload, id) => ({
    type: actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE,
    payload,
    id
  }),

  approveVatExemptionFile: (payload, id) => ({
    type: actions.APPROVE_VAT_EXEMPTION_FILE,
    payload,
    id
  }),

  rejectVatExemptionFile: (payload, id) => ({
    type: actions.REJECT_VAT_EXEMPTION_FILE,
    payload,
    id
  }),

  confirmPaymentProofFile: (payload, id) => ({
    type: actions.CONFIRM_PAYMENT_PROOF_FILE,
    payload,
    id
  }),

  resetFinanceOperations: () => ({
    type: actions.RESET_FINANCE_OPERATIONS
  }),

  viewConfidentialBankDetails: payload => ({
    type: actions.VIEW_CONFIDENTIAL_BANK_DETAILS,
    payload
  }),

  editInvoice: (payload, id) => ({
    type: actions.EDIT_INVOICE,
    payload,
    id
  }),

  viewInvoicePDF: (payload, id) => ({
    type: actions.VIEW_INVOICE_PDF,
    payload,
    id
  }),

  viewVatReversalAttachment: (payload, id) => ({
    type: actions.VIEW_VAT_REVERSAL_ATTACHMENT,
    payload,
    id
  }),

  viewPaymentProofPDF: (payload, id) => ({
    type: actions.VIEW_PAYMENT_PROOF_PDF,
    payload,
    id
  }),

  requestInvoiceApproval: (urls, payload) => ({
    type: actions.REQUEST_INVOICE_APPROVAL,
    urls,
    payload
  }),

  requestVatExemptReversal: (urls, payload) => ({
    type: actions.REQUEST_VAT_EXEMPT_REVERSAL,
    urls,
    payload
  }),

  fetchReversalRequestByID: (id) => ({
    type: actions.FETCH_REVERSAL_REQUEST_BY_ID,
    id
  }),
  
  approveVatExemptReversal: (payload, id) => ({
    type: actions.APPROVE_VAT_EXEMPT_REVERSAL,
    payload,
    id
  }),

  rejectVatExemptReversal: (payload, id) => ({
    type: actions.REJECT_VAT_EXEMPT_REVERSAL,
    payload,
    id
  }),


  fetchAllFinanceUsers: () => ({
    type: actions.FETCH_ALL_FINANCE_USERS
  }),

  getS3UrlESignature: (key, files) => ({
    type: actions.STORE_ESIGNATURE,
    key,
    files
  }),

  rejectInvoice: payload => ({
    type: actions.REJECT_INVOICE,
    payload
  }),

  approveInvoice: (urls, payload) => ({
    type: actions.APPROVE_INVOICE,
    urls,
    payload
  }),

  getS3UrlsReversalAttachment: (key, files) => ({
    type: actions.STORE_VAT_REVERSAL_ATTACHMENT,
    key,
    files
  }),

  getS3UrlsPaymentProof: (key, files) => ({
    type: actions.STORE_PAYMENT_PROOF_FOR_UPLOAD,
    key,
    files
  }),

  managePaymentProofFiles: (urls, payload, id) => ({
    type: actions.MANAGE_PAYMENT_PROOF_FILES,
    urls,
    payload,
    id
  }),

  sendMerchantInvoiceFile: payload => ({
    type: actions.SEND_MERCHANT_INVOICE,
    payload
  }),

  fetchSettlementRateByID: payload => ({
    type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
    payload
  }),

  fetchAllSettlementCycleData: (payload, pagination) => ({
    type: actions.FETCH_ALL_SETTLEMENT_CYCLE,
    payload,
    pagination
  }),

  fetchSettlementCycleByID: payload => ({
    type: actions.FETCH_SETTLEMENT_CYCLE_BY_ID,
    payload
  }),

  addNewSettlementCycle: payload => ({
    type: actions.ADD_SETTLEMENT_CYCLE,
    payload
  }),

  editSettlementCycle: (payload, id) => ({
    type: actions.EDIT_SETTLEMENT_CYCLE,
    payload,
    id
  }),

  fetchAllBillingAdditionalFee: (payload, currentList) => ({
    type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE,
    payload,
    currentList
  }),

  fetchBillingAdditionalFeeByID: (payload, merchantID) => ({
    type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID,
    payload,
    merchantID
  }),

  createBillingAdditionalFee: payload => ({
    type: actions.CREATE_BILLING_ADDITIONAL_FEE,
    payload
  }),

  updateBillingAdditionalFee: payload => ({
    type: actions.UPDATE_BILLING_ADDITIONAL_FEE,
    payload
  }),

  fetchBillingConfigurationLogs: (payload, pagination) => ({
    type: actions.FETCH_BILLING_CONFIGURATION_LOGS,
    payload,
    pagination
  }),

  generateSummaryBreakdownReport: payload => ({
    type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT,
    payload
  }),

  generateSummaryBreakdownReportV2: payload => ({
    type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2,
    payload
  }),

  editMerchantPaymentChannelSettlement: payload => ({
    type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT,
    payload
  }),

  createChangeRequestRates: (urls, payload) => ({
    type: actions.CREATE_CHANGE_REQUEST_RATES,
    urls,
    payload
  }),

  fetchFeeHistory: (payload, pagination) => ({
    type: actions.FETCH_FEE_HISTORY,
    payload,
    pagination
  }),
  rejectChangeRequestRates: payload => ({
    type: actions.REJECT_CHANGE_REQUEST_RATES,
    payload
  }),

  approveChangeRequestRatesBySales: payload => ({
    type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES,
    payload
  }),
  approveChangeRequestRatesByFinance: payload => ({
    type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE,
    payload
  }),

  fetchAllGeneratedSettlementSummaryReportData: (payload, pagination) => ({
    type: actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA,
    payload,
    pagination
  }),

  downloadAddendumDocument: (id, payload) => ({
    type: actions.DOWNLOAD_ADDENDUM_DOCUMENT,
    id,
    payload
  }),

  downloadSettlementSummaryReport: (payload, pagination) => ({
    type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT,
    payload,
    pagination
  }),

  downloadMonthlyReconciledReport: payload => ({
    type: actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT,
    payload
  }),

  getS3UrlsAddendumFile: payload => ({
    type: actions.STORE_ADDENDUM_FOR_UPLOAD,
    payload
  }),

  editMerchantSettlementPaymentChannels: (urls, payload) => ({
    type: actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS,
    urls,
    payload
  }),

  setSummaryBreakdownReportPchannelFilter: payload => ({
    type: actions.SET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER,
    payload
  }),

  resetSummaryBreakdownReportPchannelFilter: () => ({
    type: actions.RESET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER
  }),
  resetGeneratedMonthlyReconciledFilter: () => ({
    type: actions.RESET_GENERATED_MONTHLY_RECONCILED_FILTER
  }),

  saveSummaryBreakdownReportPChannelFilter: payload => ({
    type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER,
    payload
  }),

  fetchSummaryBreakdownReportPchannelFilter: () => ({
    type: actions.FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER
  }),

  resetAddendumFileURLs: () => ({
    type: actions.RESET_ADDENDUM_FOR_UPLOAD
  }),

  tagAsFloating: payload => ({
    type: actions.TAG_AS_FLOATING,
    payload
  }),

  findSingleTransactionLoosely: payload => ({
    type: actions.FIND_SINGLE_TRANSACTION_LOOSELY,
    payload
  }),

  getS3UrlsForReconProof: (key, files) => ({
    type: actions.STORE_RECON_PROOF_FOR_UPLOAD,
    key,
    files
  }),

  confirmManualRecon: (urls, payload, filter) => ({
    type: actions.CONFIRM_MANUAL_RECON,
    urls,
    payload,
    filter
  }),

  downloadManualReconProof: payload => ({
    type: actions.DOWNLOAD_MANUAL_RECON_PROOF,
    payload
  }),

  createTransactionDeletionRequest: payload => ({
    type: actions.CREATE_TRANSACTION_DELETION_REQUEST,
    payload
  }),

  fetchTransactionRequests: (payload, pagination) => ({
    type: actions.FETCH_TRANSACTION_REQUESTS,
    payload,
    pagination
  }),

  updateTransactionRequestStatus: (payload, id) => ({
    type: actions.UPDATE_TRANSACTION_REQUEST_STATUS,
    payload,
    id
  }),

  createCategorizeFloatingTransactionRequest: payload => ({
    type: actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST,
    payload
  }),

  createTaggingForReviewReconciledTransactionRequest: payload => ({
    type: actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST,
    payload
  }),

  tagReconciledTransaction: payload => ({
    type: actions.TAG_RECONCILED_TRANSACTION,
    payload
  }),

  tagUnmatchedAsEndorsed: payload => ({
    type: actions.TAG_UNMATCHED_AS_ENDORSED,
    payload
  }),

  fetchApprovedFilteredDate: payload => ({
    type: actions.FETCH_ALL_APPROVED_FILTERED_DATE,
    payload
  }),

  notifyUnreconciledTransactions: payload => ({
    type: actions.NOTIFY_UNRECONCILED_TRANSACTIONS,
    payload
  }),

  fetchApprovedFilteredDatePChannelDetails: payload => ({
    type: actions.FETCH_APPROVED_FILTERED_DATE_DETAILS,
    payload
  }),

  fetchUnreconciledPTIGroupMerchant: payload => ({
    type: actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT,
    payload
  }),

  generateSummaryReconciliationReport: payload => ({
    type: actions.GENERATE_SUMMARY_RECONCILIATION_REPORT,
    payload
  }),

  fetchGeneratedReconciliationSummaryReportFiles: (payload, pagination) => ({
    type: actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES,
    payload,
    pagination
  }),

  downloadGeneratedReconciliationSummaryReport: payload => ({
    type: actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT,
    payload
  }),

  downloadUploadedBankFile: payload => ({
    type: actions.DOWNLOAD_UPLOADED_BANK_FILE,
    payload
  })
};
export default actions;
